export default "/images/vendor/@alquiler-argentina/aa-componentes/es/upload-bro.svg?72fa3da86642066af77f808a4770657e";